export default "__VITE_ASSET__acdd20d5__"